import { useState, useMemo } from 'react';
import useDishStore from '../store/dishStore';
import useIngredientStore from '../store/ingredientStore';
import useRestaurantStore from '../store/restaurantStore';

const useGlobalSearch = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const { dishes } = useDishStore();
  const { ingredients } = useIngredientStore();
  const { restaurants } = useRestaurantStore();
  
  const searchResults = useMemo(() => {
    if (!searchQuery) return [];
    
    const query = searchQuery.toLowerCase();
    
    // Search dishes
    const dishResults = dishes
      .filter(dish => 
        dish.name.toLowerCase().includes(query) ||
        dish.description?.toLowerCase().includes(query)
      )
      .map(dish => ({
        ...dish,
        type: 'dish',
        label: dish.name,
        subtitle: dish.description
      }));
    
    // Search ingredients  
    const ingredientResults = ingredients
      .filter(ingredient => 
        ingredient.name.toLowerCase().includes(query)
      )
      .map(ingredient => ({
        ...ingredient,
        type: 'ingredient', 
        label: ingredient.name,
        subtitle: `Unit: ${ingredient.unit}`
      }));

    const restaurantResults = restaurants
      .filter(restaurant => 
        restaurant.name.toLowerCase().includes(query)
      )
      .map(restaurant => ({
        ...restaurant,
        type: 'restaurant', 
        label: restaurant.name,
        subtitle: `Address: ${restaurant.address}`
      }));
    
    return [...dishResults, ...ingredientResults, ...restaurantResults];
  }, [searchQuery, dishes, ingredients, restaurants]);
  
  return { searchQuery, setSearchQuery, searchResults };
};

export default useGlobalSearch;